import { useTypedDispatch, useTypedSelector } from 'App/Store'
import PlayoffRoundCard from 'components/PlayoffRoundCard'
import PrizeDistribution from 'components/PrizeDistribution'
import { addRewards, getRewards } from 'core/services/Groups'
import { useEffect, useState } from 'react'
import { Link,useParams } from 'react-router-dom'
import { hideLoader, showLoader } from 'redux/action/loaderAction'
import { playoffRoundsList } from 'redux/action/playoffRoundsAction'
import { Button, Col, Drawer, Modal, Row } from 'rsuite'
import { DEFAULT_API_ERROR } from 'core/constants/Defaults'
import ViewRewards from 'components/ViewRewards'
import { Reward } from 'core/models/Reward'
import { useNotification } from 'shared/hooks/useNotification'

interface UrlParams {
  tournamentId: string;
}

const BLANK_REWARD: Reward = {
  amount: 0,
  id: 0,
  currency: '',
  inGameName: '',
  rewardedBy: 0,
  teamName: '',
  tournamentId: '',
  userId: 0,
  userName: '',
  name: ''
}

export default function PlayoffRounds() {

  const urlParams = useParams<UrlParams>()
  const dispatch = useTypedDispatch()
  const playoffRoundDetails = useTypedSelector(state => state.playoffRoundDetails)
  const { isLoading, playoffRounds, prizeConfig, winnerTeams, rewarded, tournamentCompleted } = playoffRoundDetails
  const [showPrize, setShowPrize] = useState(false)
  const [showReward, setShowReward] = useState(false)
  const showNotification = useNotification()
  const [rewards, setRewards] = useState<Reward[]>([])
  const [screenWidth, setScreenWidth] = useState(0)
  const [isMobile, setMobile] = useState(true)


  useEffect(() => {
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  function handleResize() {
    setScreenWidth(
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth
    )
  }

  useEffect(() => {
    if (screenWidth > 540) {
      setMobile(false)
    }
    else setMobile(true)
  }, [screenWidth])



  useEffect(() => {
    dispatch(playoffRoundsList({ id: urlParams.tournamentId }))

  }, [dispatch, urlParams.tournamentId])

  useEffect(() => {
    if (isLoading) {
      dispatch(showLoader())
    } else {
      dispatch(hideLoader())
    }
  }, [isLoading, dispatch])

  function handleClose() {
    setShowPrize(false);
  }

  function handlePrizeDistributionOpen() {
    setShowPrize(true);
  }

  function handlePrizeDistribution(prizeData: any) {
    dispatch(showLoader())
    addRewards({ ...prizeData, tournId: urlParams.tournamentId })
      .then(resp => {
        if (resp.status && resp.data) {
          dispatch(playoffRoundsList({ id: urlParams.tournamentId }))
          showNotification({
            message: 'Rewards Added Successfully',
            title: 'Success',
            type: 'success'
          })
        } else {
          showNotification({
            message: resp.message || DEFAULT_API_ERROR,
            title: 'Error',
            type: 'error'
          })
        }
        handleClose()
        dispatch(hideLoader())
      })
  }

  async function handleViewReward() {
    const rewardRes = await getRewards(urlParams.tournamentId)
    if (rewardRes.status && rewardRes.data) {
      const rewardsData = rewardRes.data.rewards.map(reward => {
        if (reward.currency === 'XOCOINS') {
          reward.currency = 'XO Coins'
        } else {
          reward.currency = 'XO Points'
        }
        return reward
      })
      // Adding blank record to maintain height issue in modal. this is temporary fix
      if (rewardsData.length > 4) {
        rewardsData.push(BLANK_REWARD)
      }
      setRewards(rewardsData)
      setShowReward(true)
    } else {
      showNotification({
        message: rewardRes.message || DEFAULT_API_ERROR,
        title: 'Error',
        type: 'error'
      })
    }
  }

  function closeViewReward() {
    setTimeout(() => { setRewards([]) }, 300)
    setShowReward(false)
  }

  return (
    <div className='playoff-round-container'>
      <div className="prize-distribution-container">
        <div className="playoff-round-title">
          <Link to="/playoff/tournaments" className="nav-back">
            Playoff / Tournament /
          </Link>
          <span> Round</span>
        </div>
        {/* <div className='playoff-round-title'>
          Rounds
        </div> */}
        {
          Boolean(prizeConfig?.length && tournamentCompleted && !rewarded) &&
          <Button id='add-result-btn' appearance="primary" onClick={handlePrizeDistributionOpen} size={"sm"}>Add Reward</Button>
        }
        {
          Boolean(prizeConfig?.length && tournamentCompleted && rewarded) &&
          <Button id='view-reward-btn' appearance="primary" onClick={handleViewReward} size={"sm"}>View Reward</Button>
        }
      </div>
      <Row >
        {
          playoffRounds.map(
            round =>
              <Col key={round.roundSequence} xs={24} sm={12} md={6} lg={6} >
                <PlayoffRoundCard roundDetails={round} />
              </Col>
          )
        }
      </Row>
      {
        isMobile ?
          <Drawer placement="bottom" onHide={handleClose} show={showPrize} style={{ height: 'var(--app-height)' }}>
            <Drawer.Header>
              <Drawer.Title>Prize Distribution</Drawer.Title>
            </Drawer.Header>
            <Drawer.Body>
              {
                showPrize &&
                <PrizeDistribution
                  onClose={handleClose}
                  teams={winnerTeams}
                  prizeConfig={prizeConfig}
                  onAddRewards={handlePrizeDistribution}
                />
              }
            </Drawer.Body>
          </Drawer>
          :
          <Modal onHide={handleClose} show={showPrize} size='md'>
            <Modal.Header>
              <Modal.Title>Prize Distribution</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {
                showPrize &&
                <PrizeDistribution
                  onClose={handleClose}
                  teams={winnerTeams}
                  prizeConfig={prizeConfig}
                  onAddRewards={handlePrizeDistribution}
                />
              }
            </Modal.Body>
          </Modal>
      }
      {
        isMobile ?
          <Drawer placement="bottom" onHide={closeViewReward} show={showReward}>
            <Drawer.Header>
              <Drawer.Title>Rewards</Drawer.Title>
            </Drawer.Header>
            <Drawer.Body>
              <ViewRewards
                rewards={rewards}
              />
            </Drawer.Body>
          </Drawer>
          :
          <Modal onHide={closeViewReward} show={showReward} size="lg" >
            <Modal.Header>
              <Modal.Title>Rewards</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <ViewRewards
                rewards={rewards}
              />
            </Modal.Body>
          </Modal>
      }
    </div>
  )
}
